import { render, staticRenderFns } from "./FindPass.vue?vue&type=template&id=4f9a8866&scoped=true&"
import script from "./FindPass.vue?vue&type=script&lang=js&"
export * from "./FindPass.vue?vue&type=script&lang=js&"
import style0 from "./FindPass.vue?vue&type=style&index=0&id=4f9a8866&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9a8866",
  null
  
)

export default component.exports